document.addEventListener("DOMContentLoaded", () => {
	initDisclosureInsert();
});

function initDisclosureInsert() {
	let aside = document.querySelector(".intro-section .intro-aside");
	let content = document.querySelector(".intro-section .content-holder");
	if (!aside) return;

	let mobImage = aside.querySelector(".img-holder");
	let disc = document.createElement("p");
	disc.classList.add("disclosure-tooltip-text");
	disc.setAttribute("data-bs-toggle", "tooltip");
	disc.setAttribute("data-bs-placement", "bottom");
	disc.setAttribute("title", "PaydaySay is a publisher supported by advertising that gets compensated in exchange for your clicking on links posted here. Being an independent comparison service, PaydaySay may feature sponsored services and products based on the compensation rate.");
	disc.innerText = "Advertising Disclosure";

	insertDisclosure();
	window.addEventListener("resize", insertDisclosure);

	function insertDisclosure() {
		if (window.innerWidth < 992) {
			content.prepend(disc);
		} else {
			aside.insertBefore(disc, mobImage);
		}
	}
}
